export const getFirebaseConfig = () => {
  console.log("[Firebase Config] ", process.env.REACT_APP_STAGE);

  if (process.env.REACT_APP_STAGE === "prod") {
    return {
      apiKey: "AIzaSyCcQPPrxrwNZmFgAlxuc6b5HXZDN8GME7Q",
      appId: "1:624521785440:web:d54f5e5ea8109338791305",
      authDomain: "byblack-cert.firebaseapp.com",
      databaseURL: "https://byblack-cert.firebaseio.com",
      measurementId: "G-K34PLYWDNR",
      messagingSenderId: "624521785440",
      projectId: "byblack-cert",
      storageBucket: "byblack-cert.appspot.com",
    };
  }

  return {
    apiKey: "AIzaSyDcT_2x0080mohQVlxESb49fjaIJHxalJc",
    appId: "1:954022640928:web:f2669a0042056d40e3ab45",
    authDomain: "staging-byblack-cert.firebaseapp.com",
    databaseURL: "https://staging-byblack-cert.firebaseio.com",
    measurementId: "G-R7WSS0E6TL",
    messagingSenderId: "954022640928",
    projectId: "staging-byblack-cert",
    storageBucket: "staging-byblack-cert.appspot.com",
  };
};

export const APP_URL =
  process.env.REACT_APP_STAGE === "prod"
    ? "https://certification.byblack.us"
    : "https://staging-byblack-cert.web.app";

export const FIREBASE_RAW_DOCUMENT_PATH = "raw_documents";
export const FIRESTORE_DOCUMENT_COLLECTION = "documents";
export const FIRESTORE_WAITLIST_COLLECTION = "waitlist";
export const FIRESTORE_MESSAGE_COLLECTION = "messages";
export const FIRESTORE_USER_ROLE_COLLECTION = "userRole";
export const FIRESTORE_VIDEOASK_RESPONSE_COLLECTION = "responses";
export const FIRESTORE_MIDDESK_RESPONSE_COLLECTION = "middesks";

export const FIRESTORE_INVITATION_CODE_COLLECTION = "invitationCodes";
export const INVITATION_CODE_KEY = "userInvitationCode";
export const REG_DETAILS_KEY = "registrationDetails";

export const COOKIE_STATUS = "cookieStatus";

export const GOOGLE_TRACKING_ID = "UA-150452789-1";
export const GOOGLE_TRACKING_VERSION = 1;
export const GOOGLE_TAG_MANAGER = "GTM-5XDSJVT";

export const LOGROCKET_ENDPOINT = "gkgqyk/byblackprod";
